import CallsToAciton from '@components/calls-to-action/calls-to-action.view';
import ComponentRenderer from '@components/cms-components/component-renderer/component-renderer.view';
import Img from '@components/img';
import { Madi, Yeseva } from 'app/fonts';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import type { HeaderData } from 'types/components/header';
import type { DataProps } from 'types/props/data-props';
import { validateString } from 'utils/validate-string';

import styles from './header.module.scss';
import Header from './header.view';

const decorativeHeadingClass = validateString(styles.decorativeHeading);

function HeaderComponent({
  backgroundImage,
  context,
  cursiveHeading = true,
  description,
  decorativeHeading,
  eyebrow,
  fullscreen = false,
  heading,
  layout = 'left',
  subHeading,
  image,
  imageStyle,
  primaryCta,
  secondaryCta,
  theme,
}: DataProps<HeaderData>): ReactElement {
  const headingNode =
    typeof heading !== 'undefined' ? heading : decorativeHeading;

  return (
    <Header
      backgroundImage={typeof backgroundImage !== 'undefined'}
      callsToAction={
        <CallsToAciton
          primaryCta={primaryCta}
          secondaryCta={secondaryCta}
          theme={theme}
        />
      }
      description={
        <ComponentRenderer context={context}>{description}</ComponentRenderer>
      }
      eyebrow={
        typeof eyebrow !== 'undefined' ? <span>{eyebrow}</span> : undefined
      }
      fullscreen={fullscreen}
      heading={
        <h1
          className={classNames({
            [Madi.className]: cursiveHeading === true,
            [Yeseva.className]: cursiveHeading === false,
            [decorativeHeadingClass]: typeof decorativeHeading !== 'undefined',
          })}
        >
          <ComponentRenderer context={context}>{headingNode}</ComponentRenderer>
        </h1>
      }
      layout={layout}
      media={
        typeof image !== 'undefined' ? (
          <Img
            alt="" // TODO: Fix alts
            imageSource={image}
            imageStyle={imageStyle}
            key="media"
            priority
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        ) : undefined
      }
      size={cursiveHeading === true ? 'large' : 'medium'}
      subHeading={
        typeof subHeading !== 'undefined' ? (
          <span>{subHeading}</span>
        ) : undefined
      }
      theme={theme}
    />
  );
}

export default HeaderComponent;
